import React, { Component, Fragment } from 'react';
import { TouchableOpacity, View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';

import styles from './PermissionsDescriptionSection.Styles';

class PermissionsDescriptionSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMoreContent: false,
    };
  }

  onMorePress = () => {
    this.setState(prev => ({
      isMoreContent: !prev.isMoreContent,
    }));
  };

  renderContent = content => {
    return (
      content && (
        <>
          {content.paragraphs?.map(this.renderParagraph)}
          {content.bullets?.map(this.renderBullet)}
          {content.info?.map(this.renderInfo)}
          {content.breakdown?.map(this.renderBreakdown)}
        </>
      )
    );
  };

  renderParagraph = (paragraph, i) => (
    <VFText
      key={i}
      style={styles.content(this.props.textColor)}
      localize={false}
      i18nKey={paragraph}
      testKey={FrameworkTestKeys.permissionsDescriptionSectionParaghraphText}
    />
  );

  renderBullet = (bullet, i) => (
    <View
      key={i}
      style={styles.rowContainer}
      testID={FrameworkTestKeys.permissionsDescriptionSectionBulletContainer}
    >
      <View
        style={styles.bullet(this.props.theme, this.props.textColor)}
        testID={FrameworkTestKeys.permissionsDescriptionSectionBulletView}
      />
      <VFText
        style={styles.content(this.props.textColor)}
        localize={false}
        i18nKey={bullet}
        testKey={FrameworkTestKeys.permissionsDescriptionSectionBulletText}
      />
    </View>
  );

  renderInfo = (info, i) => {
    return (
      <VFText
        key={i}
        style={styles.content(this.props.textColor)}
        testKey={FrameworkTestKeys.permissionsDescriptionSectionInfoWholeText}
      >
        <VFText
          localize={false}
          i18nKey={info[0]}
          style={styles.bold(this.props.textColor)}
          testKey={FrameworkTestKeys.permissionsDescriptionSectionInfoFirstText}
        />

        <VFText
          localize={false}
          i18nKey={info[1]}
          testKey={FrameworkTestKeys.permissionsDescriptionSectionInfoSecondText}
        />
      </VFText>
    );
  };

  renderBreakdown = (breakdown, i) => (
    <View
      key={i}
      style={styles.breakdownContainer}
      testID={FrameworkTestKeys.permissionsDescriptionSectionBreakdownView}
    >
      <VFText
        style={styles.title}
        localize={false}
        i18nKey={breakdown.title}
        testKey={FrameworkTestKeys.permissionsDescriptionSectionBreakdownTitleText}
      />
      <VFText
        style={styles.content(this.props.textColor)}
        localize={false}
        i18nKey={breakdown.description}
        testKey={FrameworkTestKeys.permissionsDescriptionSectionBreakdownDescriptionText}
      />

      {breakdown.items.map((item, index) => (
        <Fragment key={index}>
          <VFText
            style={[styles.content(this.props.textColor), styles.noMargin]}
            localize={false}
            i18nKey={item.title}
            testKey={FrameworkTestKeys.permissionsDescriptionSectionBreakdownItemTitle}
          />
          <VFText
            style={
              (styles.content(this.props.textColor), styles.boldDescription(this.props.textColor))
            }
            localize={false}
            i18nKey={item.description}
            testKey={FrameworkTestKeys.permissionsDescriptionSectionBreakdownItemDescription}
          />
        </Fragment>
      ))}
    </View>
  );

  renderMoreButton = hasMoreButton => {
    const isMore = !this.state.isMoreContent;
    const i18nKey = isMore ? 'privacy_permissions_learn_more' : 'privacy_permissions_show_less';

    return (
      hasMoreButton && (
        <TouchableOpacity testID={FrameworkTestKeys.PPOMoreButton} onPress={this.onMorePress}>
          <VFText
            style={[styles.content(), styles.more(this.props.theme, isMore)]}
            i18nKey={i18nKey}
            testKey={FrameworkTestKeys.permissionsDescriptionSectionBreakdownMoreText}
          />
        </TouchableOpacity>
      )
    );
  };

  render() {
    const { isMoreContent } = this.state;
    const { section } = this.props;

    return (
      <>
        {this.renderContent(section.content)}

        {this.renderContent(isMoreContent && section.moreContent)}

        {this.renderMoreButton(section.moreContent)}
      </>
    );
  }
}

PermissionsDescriptionSection.defaultProps = {
  theme: LightThemeColors,
};

const SectionContentPropTypes = PropTypes.shape({
  paragraphs: PropTypes.arrayOf(PropTypes.string),
  bullets: PropTypes.arrayOf(PropTypes.string),
  info: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  breakdown: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ),
});

PermissionsDescriptionSection.propTypes = {
  section: PropTypes.shape({
    content: SectionContentPropTypes.isRequired,
    moreContent: SectionContentPropTypes,
  }),
  textColor: PropTypes.string,
  theme: PropTypes.object,
};

export default withTheme(PermissionsDescriptionSection);
